var map = {
	"./decidim/avatar-multiuser.png": 167,
	"./decidim/brands/facebook.svg": 2423,
	"./decidim/brands/google.svg": 1966,
	"./decidim/brands/twitter-x.svg": 2727,
	"./decidim/cc-badge.png": 4810,
	"./decidim/decidim-logo.svg": 3749,
	"./decidim/default-avatar.svg": 8917,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 1371,
	"./decidim/icons.svg": 628,
	"./decidim/pattern.png": 4647,
	"./decidim/placeholder-card-g.svg": 8012,
	"./decidim/placeholder-card-l.svg": 7719,
	"./decidim/placeholder.jpg": 1550,
	"./decidim/remixicon.symbol.svg": 9860,
	"./decidim/vendor/social-share-button/douban.svg": 151,
	"./decidim/vendor/social-share-button/email.svg": 3376,
	"./decidim/vendor/social-share-button/facebook.svg": 5628,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 9400,
	"./decidim/vendor/social-share-button/hacker_news.svg": 2180,
	"./decidim/vendor/social-share-button/linkedin.svg": 7590,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 5503,
	"./decidim/vendor/social-share-button/pinterest.svg": 4030,
	"./decidim/vendor/social-share-button/reddit.svg": 7956,
	"./decidim/vendor/social-share-button/telegram.svg": 585,
	"./decidim/vendor/social-share-button/tumblr.svg": 4198,
	"./decidim/vendor/social-share-button/twitter.svg": 5789,
	"./decidim/vendor/social-share-button/vkontakte.svg": 8495,
	"./decidim/vendor/social-share-button/wechat.svg": 2634,
	"./decidim/vendor/social-share-button/whatsapp.svg": 9338,
	"./decidim/vendor/social-share-button/x.svg": 1296,
	"./decidim/vendor/social-share-button/xing.svg": 7208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3840;